import { useSession } from '@side/next-auth/react';
import { useIdentity } from '../modules/api-clients/hooks';

export const useUserInformationForAppHeader = () => {
  const sessionUserData = useSession()?.data?.user;

  const { data: fetchedUserData } = useIdentity(
    '/users/{userId}',
    sessionUserData?.id
      ? { params: { path: { userId: sessionUserData.id } } }
      : null,
  );

  if (fetchedUserData) {
    const fetchedEmail = fetchedUserData.contacts.find(
      (c) => c.type === 'EMAIL' && c.primary,
    )?.value;

    return {
      ...fetchedUserData,
      displayName: fetchedUserData.displayName,
      email: fetchedEmail ?? '',
      photoUrl: fetchedUserData.photoUrl ?? null,
      firstName: fetchedUserData.firstName ?? sessionUserData?.firstName,
      lastName: fetchedUserData.lastName ?? sessionUserData?.lastName,
    };
  }

  if (sessionUserData) {
    return {
      ...sessionUserData,
      email: sessionUserData.email ?? sessionUserData.loginEmail,
      displayName: sessionUserData.displayName,
    };
  }

  return undefined;
};
